<template lang="pug">
.sales-page
  .sales-page__top
    h2.h2 Продажи
    a(href='#' @click.prevent="onSidebar" v-show="this.windowWidth < 1200").sidebar-gamb
      svgicon(name='gamb')
  .sales-top
    .sales-top__title
      a(href='#' 
        v-for="link in links" 
        :key="link.name" 
        :class="[{active: activeLink === link.name}]" 
        @click.prevent="activeLink = link.name, $emit('extremes', link.name)"
      ).sales-top__link {{ link.title }}
    .sales-top__right
      .filter
        .filter-item
          v-select(
            :options=['По дням', 'По неделям', 'По месяцам']
            :searchable="false"
            :clearable="false" 
            :placeholder="'Показать по'",
            v-model="selectedTime",
            ).form__select.form__select--filter 
      .sales-top__date {{ date }}
  .tabs__title.tabs__title--hint
    a(href='#' 
      v-for="tab in tabs" 
      :key="tab.name" 
      :class="[{active: currentTab === tab.name}]" 
      @click.prevent="currentTab = tab.name"
    ).tabs__link {{ tab.title }}
  span.form__info 
    svgicon(name="info" :fill="false")
    .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
  .tickets__content
    component(:is="currentTab" :selectedTime="this.selectedTime" :activeLink="this.activeLink" @period="periodDate($event)")
    
</template>

<script>
import Income from '@/components/tabs/Income.vue'
//import Orders from '@/components/tabs/Orders.vue'
//import Tickets from '@/components/tabs/Tickets.vue'
//import Promocode from '@/components/tabs/Promocode.vue'

import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  components: {
    Income,
    //Orders,
    //Tickets,
    //Promocode
  },
  data: function() {
    return {
      activeLink: 'onstart',
      links: [
        {
          name: 'yesterday', 
          title: 'Вчера'
        },
        {
          name: 'today', 
          title: 'Сегодня'
        },
        {
          name: 'week', 
          title: 'Неделя'
        },
        {
          name: 'month', 
          title: 'Месяц'
        },
        {
          name: 'onstart', 
          title: 'Со старта продаж'
        },
      ],
      currentTab: 'income',
      tabs: [
        {
          name: 'income', 
          title: 'Доход'
        },
        {
          name: 'orders', 
          title: 'Заказы'
        },
        {
          name: 'tickets', 
          title: 'Билеты'
        },
        {
          name: 'promocode', 
          title: 'Промокоды'
        },
      ],
      windowWidth: null,
      date: null,
      selectedTime: 'По дням',
    }
  },
  mounted: function(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onSidebar',
    ]),
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    periodDate($event) {
      this.date = $event;
    }
  },
  computed:{
    ...mapGetters([
      'sidebar',
    ]),
  },
}
</script>

<style lang="scss">
.sales-top{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  &__right{
    display: flex;
    align-items: center;
  }
  .filter{
    margin: 0 20px;
  }
  &__date{
    color: #161616;
    font-size: 16px;
    font-weight: 700;
  }
}
.sales-top{
  &__title{
    display: inline-flex;
    border-radius: 18px;
    background-color: #eee;
  }
}
.sales-top__link{
  display: block;
  color: #161616;
  font-size: 16px;
  text-decoration: none;
  padding: 6px 15px 7px;
  &.active{
    box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    border-radius: 18px;
    background-color: #ffffff;
  }
}
.sales-page .tabs__title{
  margin-bottom: 20px;
}

.sales-page__top{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  .h2{
    margin-top: 0;
    margin-bottom: 5px;
  }
  .sidebar-gamb{
    margin-left: auto;
  }
}
@media (max-width: 1339px) {
  .sales__graph{
    width: 700px;
  }
}
@media (max-width: 991px) {
  .activity-inner__content{
    padding: 30px 20px;
  }
  .sales-top{
    flex-wrap: wrap;
    &__right{
      width: 100%;
      margin-top: 20px;
      .filter{
        margin-left: 0;
      }
    }
  }
  .sales__graph{
    width: 500px;
  }
}
@media (max-width: 767px) {
  .sales-top__title,
  .tabs__title{
    flex-wrap: wrap;
  }
  .tabs__title.tabs__title--hint{
    max-width: calc(100% - 30px);
  }
  .sales-info{
    margin-right: -20px;
    margin-bottom: 20px;
    flex-direction: column;
  }
  .sales__graph{
    width: 100%;
  }
  .cs-col1 {
    width: 300px; 
  } 
  .channel-sales__tr-first,
  .item-channel{
    padding-left: 15px;
    padding-right: 15px;
    font-size: 14px;
  }
  .item-channel__title{
    font-size: 14px;
  }
  .channel-sales__title{
    font-size: 12px;
    align-items: flex-end;
  }
}
@media (max-width: 479px) {
  .sales-top__right{
    flex-direction: column;
    align-items: flex-start;
    .filter-item{
      margin-bottom: 10px;
    }
  }
}
</style>